'use client';
import InviteCodeBinding from '@/components/InviteCodeBinding';
import { Suspense } from 'react';

export default function Home() {
  return (
    <Suspense>
      <InviteCodeBinding />
    </Suspense>
  );
}
